export enum CollaboratorType {
  NONE,
  TEAM,
  EMPLOYEE
}
